module.exports = __webpack_public_path__ + "images/17b20f61c72cf0fb86f7c850ce9d736d.svg";